import { render, staticRenderFns } from "./EditIndex.vue?vue&type=template&id=03640d3b&"
import script from "./EditIndex.vue?vue&type=script&lang=js&"
export * from "./EditIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports